<template>
	<section class="page page-users" v-bind:class="{ 'has-scrolled': hasScrolled }">
		<ChalkyUiPageHero
			description="Explore who's nearby or active on your favorite tables."
			title="Meet People"
			v-bind:imageUrl="$asset('image/graphic/hero-users.jpg')"
		/>

		<SceneUsers
			ref="sceneUsers"
			v-bind:activeUserCollection="activeUserCollection"
			v-bind:nearbyUserCollection="nearbyUserCollection"
			v-on:user:select="Handle_OnSelectUser"
		/>
	</section>
</template>

<script lang="ts">
	import * as Mixins from '@/Mixins';
	import ChalkySticks from '@chalkysticks/sdk';
	import PageBase from '@/Core/Page.vue';
	import { Component, Prop } from 'vue-property-decorator';

	/**
	 * Users index page controller. Owns data collections, delegates
	 * presentation to SceneUsersIndex, and handles navigation.
	 *
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package Page
	 * @project ChalkySticks App
	 */
	@Component({
		mixins: [Mixins.AutoScroll, Mixins.StickyScroll],
	})
	export default class PageUsers extends PageBase {
		/**
		 * Collection of active users to display.
		 *
		 * @type ChalkySticks.Collection.User
		 */
		@Prop({
			default: () =>
				ChalkySticks.Factory.User.collection({
					limit: 12,
					qp: {
						sort: 'active',
					},
				}),
		})
		public activeUserCollection!: ChalkySticks.Collection.User;

		/**
		 * Collection of nearby users to display.
		 *
		 * @type ChalkySticks.Collection.User
		 */
		@Prop({
			default: () =>
				ChalkySticks.Factory.User.collection({
					limit: 12,
				}),
		})
		public nearbyUserCollection!: ChalkySticks.Collection.User;

		/**
		 * Configuration for sticky behavior.
		 *
		 * @type IStickyScrollConfig
		 */
		protected stickyConfig: any = {
			scrollThreshold: 100,
		};

		/**
		 * Fetches next page of results via the Scene.
		 *
		 * @return Promise<void>
		 */
		protected async triggerLoadMore(): Promise<void> {
			await (this.$refs.sceneUsers as any).loadMore();
		}

		// region: Event Handlers
		// ---------------------------------------------------------------------------

		/**
		 * Handle user selection. Navigate to user profile page.
		 *
		 * @param PointerEvent e
		 * @param ChalkySticks.Model.User userModel
		 * @return Promise<void>
		 */
		protected async Handle_OnSelectUser(e: PointerEvent, userModel: ChalkySticks.Model.User): Promise<void> {
			this.$store.dispatch('gotoUser', userModel);
		}

		// endregion: Event Handlers
	}
</script>
